import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faList, faLocationDot, faMapLocationDot } from '@fortawesome/free-solid-svg-icons';

//STYLES
import { AbasGrid } from './styled';

interface PropsAbas {
    abaAtual: string
    mostrar: boolean
}

export const AbasDoGrid: React.FC<PropsAbas> = ({
    abaAtual,
    mostrar
}) => {

    return (
        <AbasGrid>
            <div className='indicador' data-mostrar={mostrar} data-open={abaAtual}></div>
            <div className='aba__map' data-mostrar={mostrar} data-open={abaAtual}>
                <FontAwesomeIcon className='abas__icones' icon={faMapLocationDot} />
                <span>Mapa</span>
            </div>
            <div className='aba__pontos' data-open={abaAtual}>
                <FontAwesomeIcon className='abas__icones' data-open={abaAtual} icon={faLocationDot} />
                <span>Pontos</span>
            </div>
            <div className='aba__ordenacao' data-open={abaAtual}>
                <FontAwesomeIcon className='abas__icones' data-open={abaAtual} icon={faList} />
                <span>Ordenar</span>
            </div>
        </AbasGrid>
    )
}
